import GeoUnitsPage from "../pages/GeoUnitsPage";
import IndicatorsPage from "../pages/IndicatorsPage";
import IndicatorDataPage from "../pages/IndicatorDataPage";
import UsersPage from "../pages/UsersPage";
import DataHealthPage from "../pages/DataHealthPage";

export const dashboardRoutes = [
    { path: "users", label: "Users & subscriptions", element: <UsersPage /> },
    { path: "data-health", label: "Data health", element: <DataHealthPage /> },
    { path: "geo-units", label: "Geographic Unit", element: <GeoUnitsPage /> },
    { path: "indicators", label: "Indicators", element: <IndicatorsPage /> },
    { path: "indicator-data", label: "Indicator Data", element: <IndicatorDataPage /> },
];

export const endpointsFromRoutes = (routes, prefix = "/dashboards") =>
    routes.map(({ path, label }) => ({ to: `${prefix}/${path}`, label }));
